<template>
    <div class="container"></div>
</template>

<script>
    export default {};
</script>

<style scoped lang="less">
    .container {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: url(../../assets/images/404.png) no-repeat center / cover;
    }
</style>
